/**
 * Small formatting helpers shared across screens. Keep this thin — date-fns
 * is already a dep and exposes more powerful primitives when needed.
 *
 * Tutte nella lingua dell'app (`lib/fmt.ts`, contratto di fronte `fronti/tma/lingue.md`, C7): `lingua` e'
 * l'ultimo parametro, e chi la lascia vuota prende `linguaFormato()`. Un componente la passa da
 * `useLinguaFormato()`, cosi' si ridisegna quando l'utente cambia lingua.
 */
import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';

import { formatNumero, linguaFormato, localeDateFns } from './fmt';

export function formatDateShort(iso: string | null | undefined, lingua: string = linguaFormato()): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), 'd MMM, HH:mm', { locale: localeDateFns(lingua) });
  } catch {
    return '—';
  }
}

export function formatRelative(iso: string | null | undefined, lingua: string = linguaFormato()): string {
  if (!iso) return '—';
  try {
    const date = parseISO(iso);
    const distance = formatDistanceToNowStrict(date, { addSuffix: true, locale: localeDateFns(lingua) });
    return distance;
  } catch {
    return '—';
  }
}

export function formatPrizePool(
  pool: ReadonlyArray<{ amount?: number }> | undefined,
  lingua: string = linguaFormato(),
): string | null {
  if (!pool?.length) return null;
  const total = pool.reduce((sum, slot) => sum + (slot.amount ?? 0), 0);
  if (!total) return null;
  // Era `toLocaleString('en-US')` dal primo commit (17/5, «Hub baseline»), senza una ragione scritta: il montepremi
  // e' un numero come gli altri e prende i separatori della lingua dell'app. «pts» resta com'era (testo a parte).
  return `${formatNumero(total, lingua)} pts`;
}
